export const validate = async (token: string) => {
  const response = await fetch(`${process.env.NEXT_PUBLIC_API_HOST}/api/vendor/invitations/validate`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ token }),
  })
  return await response.json()
}

export const accept = async (token: string) => {
  const response = await fetch(`${process.env.NEXT_PUBLIC_API_HOST}/api/vendor/invitations/accept`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ token }),
  })
  return await response.json()
}
